// Uncomment the line below if you create a custom dictionary
// import { setupLocale } from "../localizationManager";

export var englishStrings = {
  groupButton: "Group By Me",
  ungroupButton: "Ungroup By Me",
  selectButton: "Select Me",
  columnReorder: "Column reorder",
  hideColumn: "Hide column",
  showColumn: "Show column",
  columns: "Columns",
  makePrivateColumn: "Make column private",
  makePublicColumn: "Make column public",
  moveToDetail: "Move to Detail",
  showAsColumn: "Show as Column",
  filterPlaceholder: "Search...",
  removeRows: "Remove rows",
  showLabel: "Show",
  entriesLabel: "entries",
  entriesOnPageLabel: "Entries on Page:",
  visualizer_text: "Texts in table",
  visualizer_wordcloud: "Wordcloud",
  visualizer_histogram: "Histogram",
  visualizer_number: "Average",
  visualizer_average: "Average",
  visualizer_choices: "Table",
  visualizer_selectBase: "Chart",
  visualizer_matrix: "Chart",
  chartType_bar: "Bar",
  chartType_vbar: "Vertical Bar",
  chartType_stackedbar: "Stacked Bar",
  chartType_doughnut: "Doughnut",
  chartType_pie: "Pie",
  chartType_scatter: "Scatter",
  chartType_gauge: "Gauge",
  chartType_bullet: "Bullet",
  chartType_line: "Line",
  chartType_radar: "Radar",
  chartType_histogram: "Histogram",
  chartType_vhistogram: "Vertical Histogram",
  chartType_stackedhistogram: "Stacked Histogram",
  hideButton: "Hide",
  makePrivateButton: "Make private",
  makePublicButton: "Make public",
  showButton: "Show",
  filter: "Filter",
  resetFilter: "Reset Filter",
  changeLocale: "Change Locale",
  clearButton: "Clear",
  addElement: "Choose question to show...",
  allQuestions: "All questions",
  selectAll: "Select all",
  clearSelection: "Clear selection",
  defaultOrder: "Default Order",
  ascOrder: "Ascending",
  descOrder: "Descending",
  showMinorColumns: "Show minor columns",
  actionsColumn: "Actions",
  otherCommentTitle: "Other items and comments",
  showPercentages: "Show %",
  hidePercentages: "Hide percentages",
  exportAs: "Export As...",
  pdfDownloadCaption: "PDF",
  xlsxDownloadCaption: "Excel",
  csvDownloadCaption: "CSV",
  pdfDownloadHint: "Export as PDF",
  xlsxDownloadHint: "Export as Excel",
  csvDownloadHint: "Export as CSV",
  saveDiagramAsPNG: "Download plot as a PNG file",
  responsesText: "response(s)",
  noData: "No data",
  selectDateRange: "Select date range...",
  startDate: "Start date",
  endDate: "End date",
  includeToday: "Include today",
  reportingPeriodCustom: "Custom",
  reportingPeriodLast7days: "Last 7 days",
  reportingPeriodLast14days: "Last 14 days",
  reportingPeriodLast28days: "Last 28 days",
  reportingPeriodLast30days: "Last 30 days",
  reportingPeriodLastWeekMon: "Last week (starts Monday)",
  reportingPeriodLastWeekSun: "Last week (starts Sunday)",
  reportingPeriodLastMonth: "Last month",
  reportingPeriodLastQuarter: "Last quarter",
  reportingPeriodLastYear: "Last year",
  reportingPeriodWtdSun: "This week to date (starts Sunday)",
  reportingPeriodWtdMon: "This week to date (starts Monday)",
  reportingPeriodMtd: "This month to date",
  reportingPeriodQtd: "This quarter to date",
  reportingPeriodYtd: "This year to date",
  hideEmptyAnswers: "Hide empty answers",
  showEmptyAnswers: "Show empty answers",
  "topNValueText-1": "All answers",
  "topNValueText5": "Top 5 answers",
  "topNValueText10": "Top 10 answers",
  "topNValueText20": "Top 20 answers",
  hideMissingAnswers: "Hide missing answers",
  showMissingAnswers: "Show missing answers",
  missingAnswersLabel: "Missing answers",
  noVisualizerForQuestion: "This question type is not visualized yet",
  noResults: "There are no results yet",
  showPerValues: "Per Values",
  showPerColumns: "Per Columns",
  answer: "Answer",
  correctAnswer: "Correct answer: ",
  percentage: "Percentage",
  statistics_chart: "Chart",
  responses: "Responses",
  totalResponses: "Total responses",
  visualizer_nps: "NPS",
  visualizer_boolean: "Chart",
  visualizer_options: "Table",
  npsScore: "NPS",
  npsPromoters: "Promoters",
  npsPassives: "Passives",
  npsDetractors: "Detractors",
  axisXSelectorTitle: "Category (X Axis)",
  axisYSelectorTitle: "Legend (Series)",
  axisXAlternativeSelectorTitle: "Segments:",
  axisYAlternativeSelectorTitle: "Groups:",
  notSelected: "Not selected",
  secondYAxisToggleTitle: "Secondary Y axis",
  selectDataField: "Select a data field...",
  intervalMode_default: "Default",
  intervalMode_decades: "Decades",
  intervalMode_years: "Years",
  intervalMode_quarters: "Quarters",
  intervalMode_months: "Months",
  intervalMode_days: "Days",
  intervalMode_auto: "Auto",
  intervalModeTitle: "Intervals:",
  noRunningTotals: "Show individual values",
  runningTotals: "Show running totals",
  groupDateSeries: "Compare periods",
  ungroupDateSeries: "View timeline",
  noneAggregateText: "None",
  selectAggregateText: "Aggregate:",
  groupedYearsAxisTitle: "Year ends with",
  license: "To use the Dashboard library in your application, a <a href='https://surveyjs.io/licensing' target='_blank'>developer license</a> is required. If you have an active license, please <a href='https://surveyjs.io/remove-alert-banner' target='_blank'>set up your license key</a> and ensure you're using the <a href='https://surveyjs.io/stay-updated/release-notes' target='_blank'>latest version</a>.",
  license2: "This banner appears because your maintenance subscription for the Dashboard library expired on {date}. You may continue using <a href='https://surveyjs.io/stay-updated/release-notes' target='_blank'>all versions released up to that date</a>. To remove this banner in the latest version, please <a href='https://surveyjs.io/manage#license-manager' target='_blank'>renew your subscription</a> and <a href='https://surveyjs.io/remove-alert-banner' target='_blank'>set up a new license key</a>.",
  seriesListSeries: "Series {0}",
  seriesListValuesLabel: "Values",
  seriesListRemove: "Remove",
  seriesListAdd: "Add Series",
  seriesListMoveToSecondAxis: "Move to second axis",
  seriesListMoveToFirstAxis: "Move to first axis",
  aggregationCount: "Count",
  aggregationSum: "Sum",
  aggregationAverage: "Average",
  close: "Close",
  thousandsSuffix: "K",
  millionsSuffix: "M",
  billionsSuffix: "B"
};

// Uncomment the line below if you create a custom dictionary.
// Replace "en" with a custom locale code (for example, "fr" or "de"),
// Replace `englishStrings` with the name of the variable that contains the custom dictionary.
// setupLocale({ localeCode: "en", strings: englishStrings });
